import React, { useContext } from 'react';
import { AppContext } from 'src/components/app-context';
import { CheckboxSwitch } from '@prisjakt/ui/checkbox/variants';
import { useOfferListFilterContext } from 'src/areas/product/components/offer-list-filter-context';
import {
  FilterType,
  FilterUIPlacementEnum,
} from 'src/components/price-list/types';
import { FilterOptionWrapper, CheckboxClickarea } from '../styles';

export const IncludeShippingFilter = () => {
  const { t } = useContext(AppContext);
  const {
    getFilterByPlacement,
    getTranslatedLabel,
    toggleFilter,
  } = useOfferListFilterContext();
  const selectedFilters = getFilterByPlacement(
    FilterUIPlacementEnum.OFFERLIST_HEADER
  );

  const onPricesIncShippingOptionChanged = (filterType: FilterType) => {
    toggleFilter(filterType);
  };

  return (
    <>
      {selectedFilters.map(filter => (
        <FilterOptionWrapper key={filter.label}>
          <CheckboxClickarea>
            <CheckboxSwitch
              id={filter.label}
              text={getTranslatedLabel(t, filter.type)}
              onChange={() => onPricesIncShippingOptionChanged(filter.type)}
              checked={Boolean(filter.active)}
            />
          </CheckboxClickarea>
        </FilterOptionWrapper>
      ))}
    </>
  );
};
